<script>
    export let firebaseUser = null
    export let userRole = ""

	import { getContext } from 'svelte'

    import Preloader from "./Preloader.svelte"

    import firebase from "firebase/app"
    import "firebase/auth"
    import "firebase/firestore"
    import "firebaseui"
    
    const firebaseConsoleUrl = getContext("firebaseConsoleUrl")

    let obtainingRole = false
    let firebaseAuthUIShown = false

	firebase.auth().onAuthStateChanged(async (user) => {
        firebaseUser = user
        userRole = ""
		if (user) {
			// User is signed in, see docs for a list of available properties
			// https://firebase.google.com/docs/reference/js/firebase.User
			//var uid = user.uid;
            // ...
            obtainingRole = true
            try {
                const doc = await firebase.firestore().collection("Admins").doc(user.uid).get()
                userRole = doc.exists ? doc.data().role : ""
            }
            finally {
                obtainingRole = false
            }
		} else {
			// User is signed out
            // ...
            const firebaseAuthUI = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth())
            firebaseAuthUI.start("#firebaseui-auth-container", {
                signInOptions: [
                    firebase.auth.EmailAuthProvider.PROVIDER_ID,
                    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                ],
                callbacks: {
                    uiShown: function() {
                        firebaseAuthUIShown = true
                    }
                }
            })
		}
	});

</script>

<style>
    h4 {
        text-align: center;
    }
    .collapsed {
       display: none; 
    }
</style>

<div class="col s12 m7 l8 {firebaseUser && userRole ? 'collapsed' : ''}">
    <div class="container main-container">
        {#if firebaseUser && !userRole}
            {#if obtainingRole}
                <Preloader text="Obtaining role..." />
            {:else}
                <h4>No role</h4>
                <div class="card horizontal hoverable"> 
                    <div class="card-stacked">
                        <div class="card-content">
                            <span class="card-title">Your role was not found</span>
                            <p>May be you are not in the admin list or your role is not set</p>
                        </div>
                        <div class="card-action">
                            <a href={firebaseConsoleUrl + "/firestore/data~2FAdmins"}>Admin list</a>
                        </div>
                    </div>
                </div>
            {/if}
        {/if}
        <div class="{firebaseUser ? 'collapsed' : ''}">
            {#if firebaseAuthUIShown}
                <h4>You are not signed in</h4>
            {:else}
                <Preloader text="Loading..." />
            {/if}
            <div id="firebaseui-auth-container"></div>
        </div>
    </div>
</div>